import { DEFAULT_PRESET_SETTINGS } from '@Pages/Heatmap/HeatmapSettingsDialog/constants';

export const mapDefaultSettingsFromResponse = (settingsResponse) => {
  if (!settingsResponse) return {};

  const { defaultColType, defaultRowType, defaultCellOperation } = settingsResponse;

  return {
    col: settingsResponse.cols.find((col) => col.value === defaultColType),
    row: settingsResponse.rows.find((row) => row.value === defaultRowType),
    cellOperation: defaultCellOperation,
  };
};

export const generateCurrentSettings = (settingsResponse, heatmapSettings) => ({
  ...DEFAULT_PRESET_SETTINGS,
  ...mapDefaultSettingsFromResponse(settingsResponse),
  ...heatmapSettings,
});
